import { Tab, Tabs } from "react-bootstrap";
import "./TransactionHeader.css";

const TransactionHeader = ({setStatus, totalRecords, totalServiced, totalcanceled}) => {
  return (
    <>
      <Tabs defaultActiveKey="all" id="transaction-tabs" onSelect={(eventKey) => {setStatus(eventKey)}}>
        {/* TODO: need to display api results, coordinate w Matthew */}
        <Tab eventKey="all" title={<span className="tab-title">All Transactions <span className="tab-badge">{totalServiced + totalcanceled}</span></span>}></Tab>
        <Tab eventKey="1" title={<span className="tab-title">Serviced <span className="tab-badge">{totalServiced}</span></span>}></Tab>
        <Tab eventKey="2" title={<span className="tab-title">Canceled <span className="tab-badge">{totalcanceled}</span></span>}></Tab>
      </Tabs>
      <div className="table-header">
        <div className="placeholder-icon"></div>
        <div>Language</div>
        <div>Request Time</div>
        <div>Duration</div>
        <div>Transaction ID</div>
        <div>Interpreter</div>
        <div>Interpreter ID</div>
        <div>More Info</div>
      </div>
    </>
  );
};

export default TransactionHeader;
